/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Expand Bar Icon component.
 */
export const SideNavExpandBarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.6426 1C20.3326 1.00045 20.8926 1.55992 20.8926 2.25V21.9561C20.8923 22.6459 20.3324 23.2056 19.6426 23.2061H4.25C3.55983 23.2061 3.00031 22.6461 3 21.9561V2.25C3 1.55965 3.55964 1 4.25 1H19.6426ZM16.4648 21.7061H19.3926V2.5H16.4648V21.7061ZM4.5 21.7061H14.9648V2.5H4.5V21.7061ZM12.377 12.1025L8.17969 16.416L7.2002 15.4102L10.418 12.1025L7.2002 8.79492L8.17969 7.78906L12.377 12.1025Z' fill={iconColor} />
    </svg>
  );
};

export default SideNavExpandBarIcon;
